<template>
  <div class="questionnaire" v-if="questionnaire.ID">
    <div v-if="loggedIn">
      <v-form @submit.prevent="submitVotes" v-if="hasQuestions && canVote" class="questions">
        <PanelsToggle
          v-model="openQuestions"
          :panels="this.questionnaire.questions.map((_,i) => i)"
          v-if="hasActiveQuestions"
        ></PanelsToggle>

        <v-expansion-panels v-model="openQuestions" multiple>
          <template v-for="question in questionnaire.questions">
            <v-expansion-panel :key="question.id" class="mt-5 mb-5" v-if="question.active == 1 && !question.alreadyVoted">
              <v-expansion-panel-header class="title">{{ question.text }}</v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-divider class="mb-5"></v-divider>

                <div class="max-choices" v-if="question.type === 'multiple' && question.max_choices > 0">
                  Максимален брой отговори: {{ question.max_choices }} (Избрани: {{ numSelected(question) }})
                </div>

                <Choices @custom-change="formChanged()" v-model="question.choices" :max="question.max_choices" :type="question.type"></Choices>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </template>
        </v-expansion-panels>

        <v-btn
          color="primary"
          v-if="hasActiveQuestions"
          class="mt-5 mb-5 mr-4"
          @click="submitVotes"
          :disabled="loading || answers.length === 0"
        >
          Гласувай  <v-icon class="ml-3">send</v-icon>
        </v-btn>
      </v-form>

    </div>
    <Results v-if="typeof questionnaire.ID !== 'undefined'" :questionnaire="questionnaire"></Results>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import Results from '@/components/Voting/Results.vue'
import Choices from '@/components/Voting/Choices.vue'
import PanelsToggle from '@/components/Buttons/PanelsToggle.vue'

export default {
  name: 'Questionnaire',
  props: ['id'],
  data () {
    return {
      formDirty: false,
      openQuestions: [],
      intervals: [],
    }
  },

  components: { Results, Choices, PanelsToggle },

  mounted () {
    this.fetchQuestionnaire()

    // this.$store.commit('showAlert', { type: 'error', message: 'Трябва да влезете в потребителския си профил, за да гласувате' })
  },

  beforeDestroy() {
    this.formDirty = false;
    for (const interval of this.intervals) {
      clearInterval(interval)
    }
  },

  methods: {
    numSelected (question) {
      return question.choices.filter(c => c.selected).length
    },

    formChanged() {
      this.formDirty = true
    },

    fetchQuestionnaire () {
      this.$store.commit('setLoading', true)
      this.$store.dispatch('getQuestionnaire', this.id).then(() => {
        this.$store.commit('setLoading', false)

        if (this.loggedIn && !this.hasActiveQuestions && !this.userVoted) {
          this.$store.commit('showAlert', { type: 'error', message: 'Анкетата не съдържа активни въпроси.' })
        } else {
          this.openQuestions = this.questionnaire.questions.map((_,i) => i)
        }
      }).catch(() => {
        this.$store.commit('setLoading', false)
      })

      const interval = setInterval(() => {
        if (this.formDirty) {
          return;
        }
        return this.$store.dispatch('getQuestionnaire', this.id).then(() => {
          this.$store.commit('setLoading', false)

          if (this.loggedIn && !this.hasActiveQuestions && !this.userVoted) {
            this.$store.commit('showAlert', { type: 'error', message: 'Анкетата не съдържа активни въпроси.' })
          } else {
            this.openQuestions = this.questionnaire.questions.map((_,i) => i)
          }
        }).catch(() => {
          this.$store.commit('setLoading', false)
        })
      }, 5000)

      this.intervals.push(interval)
    },

    submitVotes () {
      this.$store.commit('setLoading', true)

      this.$store.dispatch('voteOnQuestionnaire', { id: this.id, answers: this.answers })
        .then(() => {
          this.formDirty = false;
          this.fetchQuestionnaire()
          this.$store.commit('setLoading', false)
          this.$store.dispatch('getResults', this.id)
        })
        .catch((err) => {
          console.log(err)
          this.$store.commit('setLoading', false)
          this.$store.commit('showError', 'Грешка при изпращането на гласовете.')
        })
    }
  },

  computed: {
    ...mapGetters(['loggedIn', 'questionnaire', 'user', 'loading']),

    answers () {
      let answers = JSON.parse(JSON.stringify(
        this.questionnaire.questions.filter(q => !q.alreadyVoted && q.choices.some(c => c.selected))
      ))
      return answers.map(q => {
        q.choices = q.choices.filter(c => c.selected).map(c => c.id)
        return q
      })
    },

    hasQuestions () {
      return typeof this.questionnaire.questions !== 'undefined' && this.questionnaire.questions.length > 0 &&
          this.questionnaire.questions.some(q => !q.alreadyVoted)
    },

    canVote () {
      return this.questionnaire.can_vote
    },

    hasActiveQuestions () {
      return typeof this.questionnaire.questions !== 'undefined' &&
        typeof this.questionnaire.questions.find(q => q.active === '1' && !q.alreadyVoted) !== 'undefined'
    },

    questionsActive () {
      return this.questionnaire.questions.some(q => q.active === true)
    },

    userVoted () {
      return this.questionnaire.questions.some(q => q.alreadyVoted === true)
    }
  },

  watch: {
    reloading () {
      this.$store.dispatch('getQuestionnaire', this.id).then(() => {
        this.$store.commit('setReloading', false)
      })
    }
  },
}
</script>
